module.exports = __webpack_public_path__ + "img/monitor-white.5a3a6efc.png";